import { render, staticRenderFns } from "./CommunicationGroupMessage.vue?vue&type=template&id=2f3f4150&scoped=true&"
import script from "./CommunicationGroupMessage.vue?vue&type=script&lang=js&"
export * from "./CommunicationGroupMessage.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationGroupMessage.vue?vue&type=style&index=0&id=2f3f4150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3f4150",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardText,VIcon,VTab,VTabs,VTabsSlider})
